import { render, staticRenderFns } from "./PagamentoDetalhar.vue?vue&type=template&id=a68a97f2&"
import script from "./PagamentoDetalhar.vue?vue&type=script&lang=js&"
export * from "./PagamentoDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports